import React from "react";
import { faqs } from "../mock";
import { Link } from "react-router-dom";
import { ServiceAreaMap } from "./ServiceAreaMap";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  return (
    <section className="py-24 bg-brand-50/50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center">
          <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">
            Häufige Fragen
          </div>
          <h2 className="mt-3 font-display text-[36px] md:text-[46px] leading-tight font-extrabold text-brand-900">
            Alles, was Sie wissen sollten.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-brand-100 px-6 data-[state=open]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-brand-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-brand-700 leading-relaxed pb-5">
                {f.a}
                {f.link && (
                  <div className="mt-3">
                    <Link to={f.link.to} className="underline text-brand-900 font-medium">
                      {f.link.label}
                    </Link>
                  </div>
                )}
                {f.map && <ServiceAreaMap />}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
